import React, { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Layout } from "react-feather";
import { classes } from "../../../Data/Layouts";
import CustomizerContext from "../../../_helper/Customizer";
import { LI, UL } from "../../../AbstractElements";
import { getActiveLayoutSlug } from "../../../constants/layout";
import { replacePathLayoutSlug, switchLayoutSlug } from "../../../utils/themePreferences";

const HeaderLayoutThemeMenu = () => {
  const { addSidebarLayouts } = useContext(CustomizerContext);
  const navigate = useNavigate();
  const location = useLocation();
  const activeSlug = getActiveLayoutSlug(location.pathname);

  const handleSelect = (slug) => {
    if (slug === activeSlug) {
      return;
    }
    switchLayoutSlug(slug, addSidebarLayouts);
    navigate(replacePathLayoutSlug(location.pathname, slug), { replace: true });
  };

  return (
    <LI attrLI={{ className: "credora-layout-theme-item onhover-dropdown pe-0 py-0" }}>
      <button
        type="button"
        className="credora-layout-theme-btn"
        title="Change layout theme"
        aria-label="Change layout theme">
        <Layout size={18} />
      </button>
      <UL attrUL={{ className: "simple-list credora-layout-theme-menu onhover-show-div" }}>
        <li className="credora-layout-theme-menu__title">Layout theme</li>
        {classes.map((entry) => {
          const slug = Object.keys(entry)[0];
          const isActive = slug === activeSlug;
          return (
            <LI
              key={slug}
              attrLI={{
                className: isActive ? "is-active" : "",
                onClick: () => handleSelect(slug),
              }}>
              <span>{slug}</span>
              {isActive ? <span className="credora-layout-theme-menu__check">✓</span> : null}
            </LI>
          );
        })}
      </UL>
    </LI>
  );
};

export default HeaderLayoutThemeMenu;
